module.exports = __webpack_public_path__ + "static/img/8.f4bada8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/8.png
// module id = rGu8
// module chunks = 0